import { Checkbox } from '@deque/cauldron-react';
import classNames from 'classnames';
import React from 'react';
import { Trans } from 'react-i18next';
import styles from './ConsentCheckbox.css';

export interface ConsentCheckboxProps {
  id: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  describedBy?: string;
  error?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkboxRef: React.Ref<HTMLInputElement>;
}

const ConsentCheckbox = ({
  id,
  name,
  checked,
  disabled,
  invalid,
  error,
  className,
  onChange,
  checkboxRef,
  describedBy
}: ConsentCheckboxProps): React.ReactElement => {
  return (
    <Checkbox
      id={id}
      className={classNames(styles.Checkbox, className)}
      label={
        <span>
          <Trans>
            You may contact me with product updates and usage-based
            recommendations.
          </Trans>
        </span>
      }
      name={name}
      checked={checked}
      disabled={disabled}
      checkboxRef={checkboxRef}
      aria-invalid={!!invalid}
      aria-describedby={describedBy}
      error={error}
      onChange={onChange}
    />
  );
};

export default ConsentCheckbox;
